export const DepositModeEnum = {
    None: 0,
    Cash: 1,
    Card: 2,
    Both: 3,
};